
import { EventManager } from './event-manager.service';

export class ModuleManagerService {

	components: Element[];
	modules: string[];
	event: EventManager;

	constructor() {}

	init() {

		this.components = Array.from(document.querySelectorAll('[data-component]'));
		this.event = EventManager.Instance;
		this.assemble();

	}

	assemble() {

		this.components.forEach((item, index) => {

			const currentComponent = this.purify(this.components[index].getAttribute('data-component'));

			this.compile(currentComponent, this.components[index]);

		});

		this.event.emit('componentsLoaded');

	}

	purify(name: string) : string {

		if (name.includes('-')) {

			return name.split('-').map( (item) => {
				return item = item.substring(0, 1).toUpperCase() + item.substring(1);
			}).join('');

		} else {

			return name.substring(0, 1).toUpperCase() + name.substring(1);

		}

	}

	compile(moduleName: string, el: Element) {

		if (typeof this.modules[moduleName] === 'function') {

			new this.modules[moduleName](el);

		} else {

			console.warn(`Looked for module '${moduleName}' but could'nt find it. Check if it's registered in the app.ts file`);

		}

	}

}



// WEBPACK FOOTER //
// ./services/module-manager.service.ts